import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {TableModel} from '../table/table-model';
import { TitleCasePipe } from '@angular/common';

/**
 * Content modal window that is showed when user clicks on number of migration details number or exclusions.
 */
@Component({
	selector: 'app-migration-details-modal-content',
	templateUrl: './migration-details-modal-content.component.html',
	styleUrls: ['./migration-details-modal-content.component.scss']
})
export class MigrationDetailsModalContentComponent implements OnInit {

	@Input() modalTitle: string;
	@Input() migrationRecordsDetails: Array<any>;
	migrationRecordsDetailsTableModel: TableModel<any>;

	constructor(public activeModal: NgbActiveModal, private titleCasePipe: TitleCasePipe) {
	}

	ngOnInit(): void {
		this.migrationRecordsDetailsTableModel = this.createTableModel();
	}

	private createTableModel(): TableModel<any> {
		if (this.migrationRecordsDetails == null) {
			return null;
		}

		const model = new TableModel<any>();
		model.setItems(this.migrationRecordsDetails);
		const firstItem = this.migrationRecordsDetails[0];
		const renamedFields = this.addRenamedColumns(firstItem, model);
		this.addAllOtherColumns(renamedFields, firstItem, model);

		return model;
	}

	private addRenamedColumns(firstItem, model: TableModel<any>) {
		const renamedFields = new Map<string, string>();
		renamedFields.set('name', 'Client name');
		renamedFields.set('id', 'Portal Id');
		renamedFields.set('Alert Type', 'Exclusion type');
		renamedFields.forEach((fieldToRenameTo, fieldToRenameFrom) => {
			if (firstItem[fieldToRenameFrom]) {
				model.addColumn({
					columnHeaderText: this.titleCasePipe.transform(fieldToRenameTo),
					getValueFunction: item => item[fieldToRenameFrom]
				});
			}
		});
		return renamedFields;
	}


	private addAllOtherColumns(renamedFields: Map<string, string>, firstItem, model: TableModel<any>) {
		const isNotRenamedField = (key) => !renamedFields.has(key);
		const allOtherFields = Object.keys(firstItem)
			.filter(isNotRenamedField);
		allOtherFields.forEach((key) => {
			model.addColumn({
				columnHeaderText: this.titleCasePipe.transform(key),
				getValueFunction: item => item[key]
			});
		});
	}
}
